export const styles = {
  wrapper: { padding: '0 3rem' },
}
